import { faTemperatureFull, faDroplet, faCloudRain } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import clsx from "clsx";
import { Row, Col } from 'react-bootstrap';

import styles from './ObservationStats.module.css';
import { determineObservationClass } from '../helpers/ObservationsHelper.js';
import ObservationItem from './ObservationItem.jsx';
import ObservationMultiItem from './ObservationMultiItem.jsx';
import DataSource from './DataSource.jsx';

function ObservationStats({observationsData, title = undefined}) {
  const {t} = useTranslation();
  const {station, latestObservation, change} = observationsData || {};
  const {observations, timestamp} = latestObservation || {};
  const observationClass = observations && change ? determineObservationClass(observations, change) : null;
  
  console.log(observations, change, observationClass);
  
  return (
    <div className={clsx(styles.ObservationWrapper)}>
      <h4 className={styles.ObservationTitle}>
        {title || `${station?.name} - ${t('observations.latest_observations')}`}
      </h4>
      <Row>
        <Col xs={12} sm={6} md={6} lg={6}  className={styles.ObservationCol}>
          <ObservationItem
            label={t('observations.temperature')}
            icon={faTemperatureFull}
            primaryValue={observations?.temperature_c_air}
            secondaryValue={observations?.temperature_c_apparent ? t('observations.stats.feels_like_value', {value: observations?.temperature_c_apparent}) : undefined}
            unit="°C"
          />
          <ObservationItem
            label={t('observations.relative_humidity')}
            icon={faDroplet}
            primaryValue={observations?.humidity_percent_relative}
            secondaryValue={observations?.temperature_c_dewpoint ? t('observations.stats.dew_point_value', {value: observations?.temperature_c_dewpoint}) : undefined}
            unit="%" ready={observations} />
        </Col>
        <Col xs={12} sm={6} md={6} lg={6}  className={styles.ObservationCol}>
          <ObservationMultiItem
            label={t('observations.rainfall')}
            icon={faCloudRain}
            primaryValues={[
              change?.rainfall_change_1hr,
              observations?.rainfall_mm_9am
            ]}
            primaryValueLabels={[
              t('observations.sublabels.last_hour'),
              t('observations.sublabels.since_9am')
            ]}
            unit="mm" 
          />
          <div className="small text-muted align-self-end text-end">
            {station?.name}<br />
            { t('observations.update_time', {time: DateTime.fromISO(timestamp).setZone('system').toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)}) }
          </div>
        </Col>
      </Row>
    </div>);
}

export default ObservationStats
